import useTranslate from 'modules/local/useTranslate'
import React, {useContext} from 'react'
import {useHistory} from "../../../../modules/navigation/useRouter";
import EventContext from "../EventContext";
import {useEventApi} from "../functions/useEventApi";
import {showInfoDialog} from "../../factory/createInfoDialog";
import classNames from "classnames"

export const EventClaimReward = () => {
    const t = useTranslate()
    const history = useHistory();

    const {event} = useContext(EventContext)
    const {onClaimReward} = useEventApi({
        notifyListeners: {
            onClaimedReward: (__, data) => {
                showInfoDialog({
                    title: t("Certificate received"),
                    message: t("You have successfully claimed your certificate."),
                    translate: t,
                    onOk: () => {
                        history.push("/my-activities?rel=my-achievements")
                    }
                })
            },
        }
    });

    if (!!!event?.checkin_target) return null;
    if (!!!event?.medal?.id) return null;

    return (
        <div className="flex flex-col gap-3 items-center text-center p-6 rounded-xl shadow-lg border-t-2 border-b-2 border-green-500">
            {
                !!event?.checkin_count && !!event?.checkin_target && Number(event?.checkin_count) >= Number(event?.checkin_target) ? (
                    <h2 className="text-xl font-bold text-green-700 flex items-center gap-2">
                        {t("congratulations")}
                    </h2>
                ) : (
                    <div className="flex flex-col">
                        <h2 className="text-sm text-color-300 tracking-wider">
                            {t("This event awards a certificate")}
                        </h2>
                        <p className="font-bold text-lg text-green-700 tracking-wider">
                            {event?.medal?.title}
                        </p>
                    </div>
                )
            }
            <p className="font-medium text-sm text-color-200 tracking-wide">
                {t("you have checked in {count} / {target}", {
                    count: Number(event?.checkin_count),
                    target: Number(event?.checkin_target)
                })}
            </p>

            {!!event.reward_available ? (
                <div
                    onClick={() => onClaimReward({}, {id: event?.id})}
                    className={classNames(
                        "mt-3 px-4 py-2 flex flex-center bg-primary-500 hover:bg-primary-600",
                        "text-white font-medium rounded-lg shadow-md hover:shadow-lg cursor-pointer transition"
                    )}>
                    {t("claim reward")}
                </div>
            ) : null}
        </div>
    )
}

